// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const {
    CONTRIBUTION_PERIOD_MONTHLY,
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    MINIMUM_PERIODIC_CONTRIBUTION,
} = require('../raConstants/index');

// @utilities
const { getDay, todayDate } = require('utilities/dateHelper');
const { getPageScrollHeight } = require('../utilities/RAScrollUtils');

const initialState = Immutable.fromJS({
    error: null,
    errorFlags: false,
    initialContributionAmountError: false,
    recurringAmountError: false,
    errorChangingProduct: null,
    initialContributionAmount: 0,
    investProfileCode: '',
    investProfileDescription: '-',
    investProfileValue: '',
    investSliderValue: 1,
    isFetchingInvestProfile: false,
    isChangingProduct: false,
    isChangingProductSuccess: false,
    isFetchedInvestProfile: false,
    isSavingSimulation: false,
    maxInvestProfileValue: 1,
    modifyPlanValue: '',
    newProfile: null,
    periodicity: CONTRIBUTION_PERIOD_MONTHLY,
    portfolioCustomName: '',
    recurringContributionAmount: 0,
    recurringContributionDay: getDay(todayDate()),
    saveSuccess: false,
    selectedGoal: '',
    showDetails: true,
    includeGoal: false,
    isSaveSimulationModalOpen: false,
    isSaveSimulationButtonDisabled: true,
    isScrollHeightSet: false,
    pageScrollHeight: 0,
    isEditClicked: false,
    isFetchingValidateBlockedAccount: false,
});

function parseCustomName(value) {
    switch (value) {
        case 1:
            return 'Kuala Lumpur';
        case 2:
            return 'Shanghai';
        case 3:
            return 'Taipei';
        case 4:
            return 'New York';
        case 5:
            return 'Dubai';
        default:
            return '';
    }
}

const RAManagementPlan = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_MANAGEMENT_PLAN_UPDATE_INVEST_SLIDER: //@Todo: Remove once we get rid of slider in ModifyPlanView
            return state.merge({
                investProfileValue: action.payload.value,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_INITIAL_CONTRIBUTION_AMOUNT:
            const amount = parseFloat(action.payload.amount);
            const errorFlags =
                !!amount &&
                amount < MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT;
            return state.merge({
                initialContributionAmount: amount,
                initialContributionAmountError: errorFlags,
                errorFlags: errorFlags,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_RECURRING_CONTRIBUTION_AMOUNT:
            const recurringAmount = parseFloat(action.payload.amount);
            const errorFlag =
                !!recurringAmount &&
                recurringAmount < MINIMUM_PERIODIC_CONTRIBUTION;
            return state.merge({
                recurringAmountError: errorFlag,
                recurringContributionAmount: recurringAmount,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_PERIODICITY:
            return state.merge({
                periodicity: action.payload.periodicity,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_CONTRIBUTION_DAY:
            return state.merge({
                recurringContributionDay: action.payload.day,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_CUSTOM_NAME:
            return state.merge({
                portfolioCustomName: action.payload.name,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SHOW_DETAILS:
            return state.merge({
                showDetails: true,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_REQUEST:
            return state.merge({
                isFetchingInvestProfile: true,
                error: null,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_SUCCESS:
            const {
                initialContribution,
                maxTypeOfProduct,
                selectedPortfolio,
                hasRecurringTransfer,
                displayName,
                id,
                error,
            } = action.payload.data;

            let recurringTransfer = {};
            let newState = state;

            if (hasRecurringTransfer) {
                const {
                    amount,
                    cutDay,
                    frequencyCode,
                } = action.payload.data.recurringTransfer;

                newState = state.merge({
                    periodicity: frequencyCode,
                    recurringContributionAmount: amount,
                    recurringContributionDay: cutDay,
                });
            }

            return newState.merge({
                initialContributionAmount: initialContribution || 0,
                investProfileValue: selectedPortfolio || '',
                investSliderValue: maxTypeOfProduct || 1,
                maxInvestProfileValue: maxTypeOfProduct || 1,
                isFetchingInvestProfile: false,
                isFetchedInvestProfile: true,
                newProfile: selectedPortfolio,
                portfolioCustomName: displayName || '',
                simulationId: id,
                errorFlags:
                    initialContribution <
                        MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT &&
                    initialContribution > 0,
                recurringAmountError:
                    hasRecurringTransfer &&
                    recurringTransfer.amount < 1 &&
                    recurringTransfer.amount > 0,
                error: error,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_EDIT_CLICKED:
            return state.merge({
                isEditClicked: true,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_FAILURE:
            return state.merge({
                error: true,
                isFetchedInvestProfile: true,
                isFetchingInvestProfile: false,
                simulationId: '',
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SAVE_SIMULATION_REQUEST:
            return state.merge({
                error: null,
                isSavingSimulation: true,
                saveSuccess: false,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SAVE_SIMULATION_SUCCESS:
            return state.merge({
                saveSuccess: true,
                isSavingSimulation: false,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SAVE_SIMULATION_FAILURE:
            return state.merge({
                error: action.payload.error,
                saveSuccess: false,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_UPDATE_CUSTOM_NAME:
            return state.merge({
                portfolioCustomName: parseCustomName(action.payload.value),
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SELECT_STRATEGY:
            const value = action.payload.value;
            return state.merge({
                investProfileValue: value,
                isSaveSimulationButtonDisabled: !value,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_MODIFY_STRATEGY_AND_PROFILE:
        case actionTypes.RA_MANAGEMENT_PLAN_MODIFY_STRATEGY:
            return state.merge({
                modifyPlanValue: action.payload.newProfile,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_MODIFY_PROFILE:
            return state.merge({
                newProfile: action.payload.newProfile,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_RESET:
            return initialState;
        case actionTypes.RA_MANAGEMENT_PLAN_CHANGE_PRODUCT_REQUEST:
            return state.merge({
                isChangingProduct: true,
                isChangingProductSuccess: false,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_CHANGE_PRODUCT_SUCCESS:
            return state.merge({
                isChangingProduct: false,
                isChangingProductSuccess: true,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_CHANGE_PRODUCT_ERROR:
            return state.merge({
                isChangingProduct: false,
                isChangingProductSuccess: false,
                errorChangingProduct: action.payload.error,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_INCLUDE_GOAL:
            return state.merge({
                includeGoal: !state.get('includeGoal'),
            });
        case actionTypes.RA_SAVE_SIMULATION_CHANGE_MODAL_OPTION:
            return state.merge({
                isSaveSimulationModalOpen: action.payload.value,
            });
        case actionTypes.RA_SAVE_SIMULATION_RESET:
            return initialState.merge({
                isFetchedInvestProfile: true,
            });
        case actionTypes.RA_SAVE_SIMULATION_DISABLE_SIMULATION_BUTTON:
            return state.merge({
                isSaveSimulationButtonDisabled: action.payload.value,
            });
        case actionTypes.RA_SIMULATION_SET_SCROLL_HEIGHT:
            return state.merge({
                pageScrollHeight: getPageScrollHeight(),
                isScrollHeightSet: true,
            });
        case actionTypes.RA_SIMULATION_RESET_SCROLL_HEIGHT:
            return state.merge({
                pageScrollHeight: getPageScrollHeight(),
            });
        case actionTypes.RA_MANAGEMENT_PLAN_FETCHING_VALIDATE_BLOCKED_ACCOUNTS:
            return state.merge({
                isFetchingValidateBlockedAccount: action.payload,
            });
        default:
            return state;
    }
};

module.exports = RAManagementPlan;
